import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

const SET_ENTRIES_ORDER_PRIORITY = gql`
  mutation setEntriesOrderPriority(
    $ganttRecordId: ObjectId!
    $newEntriesOrder: [SetEntriesOrderPriorityInput!]!
  ) {
    setEntriesOrderPriority(ganttRecordId: $ganttRecordId, newEntriesOrder: $newEntriesOrder) {
      _id
    }
  }
`;

export const useSetEntriesOrderPriority = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const { t } = useTranslation(['common', 'employee']);

  const [setEntriesOrderPriority] = useMutation(SET_ENTRIES_ORDER_PRIORITY, {
    onCompleted: onSuccess,
    onError: (error: any) => {
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('notifications.error.title'),
        ...(error && { description: error.message || error.errorMessage }),
      });
    },
  });

  return setEntriesOrderPriority;
};
